import { AxiosResponse } from 'axios';
import { ApiSaleOrderService } from '../../services';
import { ISeller, ISellerTeamGoal } from './types';

const USER_SUMMARY = '/user-summary';

export const getSellers = (): Promise<AxiosResponse<ISeller[]>> => ApiSaleOrderService.get(USER_SUMMARY);

export const getSellerTeams = (): Promise<AxiosResponse<string[]>> => ApiSaleOrderService.get(`${USER_SUMMARY}/teams`);

export const updateSellerTeamGoal = (id: number, body: ISellerTeamGoal): Promise<AxiosResponse<ISeller>> =>
	ApiSaleOrderService.patch(`${USER_SUMMARY}/${id}`, body);
